<!-- src/app/components/terms-blocker/terms-blocker.component.html -->
<div class="terms-overlay">
  <ion-header>
    <ion-toolbar>
      <ion-title>Updated Terms &amp; Conditions</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content class="ion-padding">
    <ng-container *ngIf="(terms$ | async) as terms; else loadingTpl">
      <p>Date: {{ terms.publish_at }}</p>

      
      <markdown class="mdcontent" [data]="terms.markdown"></markdown>
      
      <ion-text
        color="danger"
        *ngIf="(online$ | async) === false"
        class="offline-message"
      >
        You’re currently offline. Please reconnect to accept the latest terms and conditions.
      </ion-text>

      <ion-button
        expand="block"
        color="primary"
        (click)="accept()"
        [disabled]="accepting || (online$ | async) === false"
      >
        <ion-spinner *ngIf="accepting " slot="start"></ion-spinner>
        I Agree
      </ion-button>

      
    </ng-container>

    <ng-template #loadingTpl>
      <div class="loading-container">
        <ion-spinner></ion-spinner>
        <p>Loading latest terms…</p>
      </div>
    </ng-template>
  </ion-content>
</div>
